/**
 * Bokun Prefill Banner
 *
 * iter-4c — Section-level callout shown on Storefront Identity / Storefront
 * Content / product edit pages when the vendor signed up through Bokun.
 * Tells them their storefront fields have been auto-populated and they can
 * override anything. Renders nothing for non-Bokun vendors (empty-render
 * rule).
 */

interface Props {
  /** True when the vendor has a Bokun merchant connection. */
  show: boolean
  /** Optional override of the default copy. */
  message?: string
}

export default function BokunPrefillBanner({ show, message }: Props) {
  if (!show) return null

  return (
    <div
      role="note"
      style={{
        marginBottom: '1rem',
        padding: '0.75rem 1rem',
        background: 'var(--color-info-bg, #eef4ff)',
        border: '1px solid var(--color-info-border, #c7d7f5)',
        borderRadius: '6px',
        color: 'var(--color-info-text, #1e3a8a)',
        fontSize: '0.85rem',
        lineHeight: 1.45,
      }}
    >
      <strong style={{ fontWeight: 600 }}>Prefilled from Bokun.</strong>{' '}
      {message ||
        'We have populated this section from your Bokun catalogue. Review anything below and edit where you would like to override.'}
    </div>
  )
}

/**
 * Inline "Required for full storefront" pill — sits next to the label of the
 * three fields Bokun does not supply (legal_name, founder_name, founding_year).
 * Shown only to Bokun vendors so non-Bokun signups (who provided everything
 * during onboarding) do not see redundant badges.
 */
export function RequiredForStorefrontBadge({ show }: { show: boolean }) {
  if (!show) return null
  return (
    <span
      style={{
        display: 'inline-block',
        marginLeft: '0.5rem',
        padding: '0.1rem 0.45rem',
        background: 'var(--color-warning-bg, #fff7e6)',
        color: 'var(--color-warning-text, #8a5a00)',
        border: '1px solid var(--color-warning-border, #f5d99a)',
        borderRadius: '999px',
        fontSize: '0.7rem',
        fontWeight: 500,
        verticalAlign: 'middle',
      }}
    >
      Required for full storefront
    </span>
  )
}
